import type { RootState } from "types/redux";

export const getDimensionUploadId = (state: RootState) => state.domains.customKeyIssue.upload.entityId;

export const getCustomKeyIssueUploadHasErrored = (state: RootState) => state.domains.customKeyIssue.upload.error;

export const getCustomKeyIssueIsActiveForm = (state: RootState) =>
  state.domains.customKeyIssue.upload.isCreateFormActive;

export const getCustomKeyIssueIsUploading = (state: RootState) => state.domains.customKeyIssue.upload.isPending;
